import { defineComponent as A, ref as c, computed as p } from "vue";
import { getAlgoliaSearchContracts as B } from "../../api/services/index.js";
const V = A({
  name: "SearchInput",
  props: {
    placeholder: {
      type: String,
      default: "Search this site..."
    },
    suggestions: {
      type: Array,
      required: !0
    },
    inputEnterKeyPressHandler: {
      type: Function,
      default: function() {
      }
    },
    algoliaExpVar: {
      type: String,
      required: !0
    },
    config: {
      type: Object,
      required: !0
    }
  },
  setup(r, { emit: E }) {
    const g = c(""), I = c(!1), v = p(
      () => g.value ? g.value.trim().toLowerCase() : ""
    ), y = function(e) {
      return "autocomplete-item-" + e;
    }, m = c([]), o = p(() => {
      const e = v.value;
      return e.length < 3 ? [] : r.algoliaExpVar === "N" ? m.value : r.suggestions.filter((t) => t.name.toLowerCase().includes(e)).sort((t, n) => {
        const a = t.name.toLowerCase().indexOf(e), u = n.name.toLowerCase().indexOf(e);
        return a > u ? 1 : a < u ? -1 : 0;
      }).map((t) => ({
        productName: t.name,
        productUrl: t.url
      }));
    }), h = async (e) => {
      if (E("updateQuery", e), g.value = e, e.length >= 3 && r.algoliaExpVar === "N") {
        const t = r.config.algoliaSearchUrl, n = await B(e, t);
        m.value = n;
      }
      x();
    }, C = () => {
      let e = null;
      return function(t, n) {
        clearTimeout(e), e = setTimeout(() => {
          t();
        }, n | 250);
      };
    }, N = async (e) => {
      !(e && e.productUrl && e.productName) || (await h(e.productName), r.inputEnterKeyPressHandler(e.productUrl));
    }, L = function(e) {
      const t = v.value, n = t.length;
      if (n === 0)
        return e;
      let a = "", u = e, f = 0, s = u.toLowerCase().indexOf(t);
      for (; s !== -1 && (a += u.substring(0, s) + '<span class="search-input-matched-word">' + u.substring(
        s,
        s + n
      ) + "</span>", f = s + n, !(f >= e.length)); )
        u = u.substring(f), s = u.toLowerCase().indexOf(t);
      return f < e.length && (a += u), a;
    }, P = function() {
      const e = document.getElementById(
        y(l.value)
      ), t = e?.getBoundingClientRect(), n = document.getElementById("autocomplete-list"), a = n?.getBoundingClientRect();
      if (e !== null && t && n !== null && a) {
        const u = t.y - a.y;
        t.y > n.clientHeight ? n.scrollTop = e.offsetTop + t.height - n.clientHeight : u < 0 && (n.scrollTop = e.offsetTop);
      }
    };
    let d = !1;
    const l = c(-1), i = c(""), S = c(""), b = async function() {
      d && await h(i.value), r.inputEnterKeyPressHandler(S.value);
    }, w = function(e) {
      !e && l.value < o.value.length - 1 ? l.value++ : e ? e && l.value > -1 ? l.value-- : e && l.value === -1 && (l.value = o.value.length - 1) : l.value = -1;
    }, K = function(e) {
      w(e), l.value >= 0 && l.value < o.value.length ? (i.value = o.value[l.value].productName, S.value = o.value[l.value].productUrl, d = !0, P()) : x();
    }, O = function(e) {
      T(e);
    }, T = function(e) {
      for (let t = 0; t < o.value.length; t++)
        if (o.value[t].productName === e) {
          l.value = t, i.value = e, d = !0;
          return;
        }
    }, x = function() {
      i.value = "", d = !1, l.value = -1;
    }, q = p(
      () => o.value.length !== 0
    );
    return {
      inputIsFocused: I,
      getAutocompleteId: y,
      filteredSuggestions: o,
      updateQuery: h,
      onSelected: N,
      highlightSuggestionName: L,
      handleInputEnterKeyPress: b,
      hasSuggestions: q,
      handleArrowKeyPress: K,
      currentName: i,
      onMouseEnter: O,
      debounce: C(),
      algoliaSearchSuggestions: m
    };
  }
});
export {
  V as default
};
//# sourceMappingURL=index5.js.map
